import { render, staticRenderFns } from "./PoiListModal.vue?vue&type=template&id=2a66a35f"
import script from "./PoiListModal.vue?vue&type=script&lang=ts"
export * from "./PoiListModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports